const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

// Main function to get the distance
export const getDistanceBetweenPlaces = async (place1: string, place2: string): Promise<number> => {
  const myHeaders = new Headers();
  myHeaders.append("X-Goog-Api-Key", GOOGLE_MAPS_API_KEY || "");
  myHeaders.append("X-Goog-FieldMask", "routes.distanceMeters");

  const response = await fetch(`https://routes.googleapis.com/directions/v2:computeRoutes`, {
    method: "POST",
    body: JSON.stringify({
      origin: {
        address: place1
      },
      destination: {
        address: place2
      },
      routeModifiers: {
        avoidTolls: true
      },
      travelMode: "DRIVE",
      computeAlternativeRoutes: false,
      languageCode: "en-US",
      units: "IMPERIAL"
    }),
    headers: myHeaders
  });
  const data = await response.json();
  return data?.routes ? data.routes[0].distanceMeters * 0.000621371 : 0;
};
